import React from 'react';
import Head from 'next/head';
import Intro from './Intro';
import ReadyToLearn from '@/dataroom/ui/components/Landing/researchRoom/components/ReadyToStart';
import FeaturesList from '@/dataroom/ui/components/Landing/researchRoom/pages/Features/FeaturesList';
import CustomersLogos from '@/dataroom/ui/components/Landing/researchRoom/pages/Features/CustomersLogos';

const Features = () => (
  <>
    <Head>
      <title>Features | ResearchRoom</title>
      <meta
        name="description"
        content={
          'ResearchRoom provides everything you need for seamless, ' +
          'simplified pre-deal research distribution while complying with the latest regulatory requirements.'
        }
      />
    </Head>
    <Intro />
    <FeaturesList />
    <CustomersLogos />
    <ReadyToLearn />
  </>
);

export default Features;
